export default __webpack_public_path__ + "static/06.06_Partners_logo_1280-fdc794a09fb954decaeee8eedd2de346.png";